import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface FileItem {
  id: string;
  name: string;
  type: 'file' | 'folder';
  parentId: string;
  modified: string;
  size: string | null;
  protected: boolean;
  password?: string;
  hint?: string;
}

interface FileState {
  files: FileItem[];
  currentPath: string;
  selectedFile: FileItem | null;
}

interface FileStore extends FileState {
  // Actions
  setCurrentPath: (path: string) => void;
  setSelectedFile: (file: FileItem | null) => void;
  getFilesForPath: (parentId: string) => FileItem[];
  unlockFile: (fileId: string) => void;
  resetToInitialState: () => void;
}

const initialFiles: FileItem[] = [
  {
    id: '1',
    name: 'shared',
    type: 'folder',
    parentId: 'root',
    modified: 'Now',
    size: null,
    protected: true,
    password: 'dsfe23few',
  },
  {
    id: '2',
    name: 'eval',
    type: 'folder',
    parentId: 'root',
    modified: '2 weeks ago',
    size: null,
    protected: false,
  },
  {
    id: '3',
    name: 'timeline.html',
    type: 'file',
    parentId: 'root',
    modified: 'Today',
    size: '256 KB',
    protected: true,
    password: '01302030',
    hint: 'MMDDYYYY (today)',
  },
  {
    id: '4',
    name: 'notice.txt',
    type: 'file',
    parentId: 'root',
    modified: '2 days ago',
    size: '12 KB',
    protected: false,
  },
  {
    id: '5',
    name: 'oncall_quickstart.md',
    type: 'file',
    parentId: 'root',
    modified: '1 week ago',
    size: '8 KB',
    protected: false,
  },
  {
    id: '6',
    name: 'eval_followup.md',
    type: 'file',
    parentId: '2',
    modified: '3 days ago',
    size: '8 KB',
    protected: true,
    password: 'loev?',
  },
];

const initialState: FileState = {
  files: initialFiles,
  currentPath: 'root',
  selectedFile: null,
};

export const useFileStore = create<FileStore>()(
  persist(
    (set, get) => ({
      ...initialState,

      setCurrentPath: (path) =>
        set({
          currentPath: path,
          selectedFile: null,
        }),

      setSelectedFile: (file) =>
        set({
          selectedFile: file,
        }),

      getFilesForPath: (parentId) => {
        return get().files.filter((file) => file.parentId === parentId);
      },

      unlockFile: (fileId) =>
        set((state) => ({
          files: state.files.map((file) =>
            file.id === fileId ? { ...file, protected: false } : file,
          ),
        })),

      resetToInitialState: () => set(initialState),
    }),
    {
      name: 'file-store',
      partialize: (state) => ({
        files: state.files,
        currentPath: state.currentPath,
      }),
    },
  ),
);
